import React from "react"
import { useTranslation } from "react-i18next"
import Modal from "react-modal"
import Button from "../../../shared/components/buttons/Button"
import Buttons from "../../../shared/components/layout/Buttons"
import ModalContainer from "../../../shared/components/modals/ModalContainer"
import { dialogueModalStyle, StyleVariants } from "../../../shared/state/sharedTypes"
import CaseDetails from "../../case/components/details/CaseDetails"
import DetailsCardInner from "../../../shared/components/layout/detailsCard/DetailsCardInner"
import IconCircleContainer from "../../../shared/components/icons/IconCircleContainer"
import { IconFolder } from "../../../svg/icons"
import DetailsCard from "../../../shared/components/layout/detailsCard/DetailsCard"

interface IProps {
  isOpen: boolean
  setIsOpen: (a: boolean) => void
  caseId: string
}

export default function CaseChangedModal({ isOpen, caseId, setIsOpen }: IProps) {
  const { t } = useTranslation(["shared"])

  const close = () => setIsOpen(false)
  const closeButton =
    <Button key="2" action={close} variant={StyleVariants.PURPLE} >
      {t("continue")}
    </Button>

  if (!caseId) return
  return (
    <Modal isOpen={isOpen} style={dialogueModalStyle} onRequestClose={close} >
      <ModalContainer>
        <div className="flex flex-col mt-10  justify-center">
          <div className="text-center">
            <div className="bg-ch-blue-200 flex w-full place-content-between">
              <h2 className=" p-2">The following case now is being presented:</h2>
            </div>
            <div className="flex justify-center items-center mb-5 relative">
              <DetailsCard>
                <DetailsCardInner>
                  <IconCircleContainer className="sm:mr-4">
                    <IconFolder className="fill-current w-6 h-6" title={t("shared:case")} />
                  </IconCircleContainer>
                  <CaseDetails caseId={caseId} hasLink={false} />
                </DetailsCardInner>
              </DetailsCard>
            </div>
          </div>
          <div className="flex justify-center items-center mb-5 relative">
            <Buttons buttons={[closeButton]} />
          </div>
        </div>
      </ModalContainer>
    </Modal >
  )
}
